export const STOCK_SUMMARY = "stockSummary";

